module.exports = __webpack_public_path__ + "static/media/customers5.a4404c34.png";